import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-loader-plane",
  templateUrl: "./loader-plane.component.html",
  styleUrls: ["./loader-plane.component.scss"],
})
export class LoaderPlaneComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
